// src/views/Home.jsx
import Graficas from '../components/Graficas';

const Home = () => {
  return (

    <div className="container py-0 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5">
      <div className="container-fluid mt-3">
        <h1>¡Bienvenidos a Mr Gestor!</h1>
      </div>

      <div className="container">
        <p className="lead text-secondary text-center">
          Su plataforma para gestionar de manera eficiente los procesos del programa de articulación SENA con la educación media.
        </p>
      </div>

      <div className="container">
        <h5 className="text-primary text-center mb-4">¡Explora, aprende y crece con nosotros!</h5>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-4 mb-3">
            <div className="card h-100 border-primary text-center">
              <div className="card-body">
                <h5 className="card-title text-primary">Aprendices Registrados</h5>
                <p className="card-text">Tienes 150 aprendices registrados.</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card h-100 border-success text-center">
              <div className="card-body">
                <h5 className="card-title text-success">Aprendices Activos</h5>
                <p className="card-text">Tienes 150 aprendices activos.</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card h-100 border-danger text-center">
              <div className="card-body">
                <h5 className="card-title text-danger">Aprendices Desertados</h5>
                <p className="card-text">Tienes 150 aprendices desertados.</p>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="col-12">
        <div>
          <Graficas />
        </div>
      </div>

      <div className="mb-5">

        <div className="container">
          <div className="row d-flex justify-content-between">
            <div className="col-12 col-md-9">


              <div className="row">





              </div>


            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default Home;
